import { createSlice } from "@reduxjs/toolkit";

// Global state for the Issues Detected modal (see components/policy/IssuesDetectedModal.jsx).
// Lives in Redux — rather than as local page state — so the modal can be triggered by an
// async event (policy scoring finishing over a WebSocket) regardless of which route the
// user has since navigated to.
const issuesDetectedModalSlice = createSlice({
  name: "issuesDetectedModal",
  initialState: {
    isOpen: false,
    topics: [],
  },
  reducers: {
    openIssuesDetectedModal: (state, action) => {
      state.isOpen = true;
      state.topics = action.payload?.topics ?? [];
    },
    closeIssuesDetectedModal: state => {
      state.isOpen = false;
      state.topics = [];
    },
  },
});

export const { openIssuesDetectedModal, closeIssuesDetectedModal } = issuesDetectedModalSlice.actions;

export default issuesDetectedModalSlice.reducer;
